/* フローティングメニュー */
import React from 'react';
import ScrollTopButton from '../molecules/ScrollTopButton';
var FloatingMenu = function () {
    return (React.createElement("div", { className: "floating-menu" },
        React.createElement(ScrollTopButton, null)));
};
export default FloatingMenu;
